<div class="header-container">
  <div class="logo-container">
    <!-- <a
      href="#"
      class="sidebar-toggle"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()"
    >
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a> -->
    <a class="logo" href="#" (click)="home()"><span>{{companyName}}</span></a>
  </div>
  
  <div class="mr-3" *ngIf="appSession.tenantId != null">
    <span (click)="goToReject()" style="color: blue; font-size: 17px;cursor: pointer;">المرفوضة:
      {{counts.rejectedCount}}</span>
    &nbsp;
    <span style="color: blue; font-size: 17px;">|</span>
    &nbsp;
    <span (click)="goToExternal()" style="color: blue; font-size: 17px;cursor: pointer;">الواردة:
      {{counts.externalCount}}</span>
    <!-- <code>
      <span style="color: blue; font-size: 18px;">المرفوضة: {{a}}</span>  | <span style="color: blue; font-size: 18px;">الواردة: {{b}}</span>
    </code> -->
  </div>


  <!-- <nb-select
    status="primary"
    class="theme-select"
    matRipple
    [selected]="currentTheme"
    (selectedChange)="changeTheme($event)"
  >
    <nb-option
      *ngFor="let theme of themes"
      [value]="theme.value"
      matRipple
    >{{ theme.name }}</nb-option>
  </nb-select> -->
  <!-- <button nbButton status="primary" shape="round" [nbContextMenu]="transferMenu" nbContextMenuTrigger="click">
    <nb-icon icon="trending-up-outline"></nb-icon>الحوالات
  </button>
  <button nbButton status="primary" shape="round" [nbContextMenu]="userMenu" nbContextMenuTrigger="click">
    <nb-icon icon="archive-outline"></nb-icon>الصندوق
  </button> -->
  <!-- <button nbButton status="primary" shape="round" [nbContextMenu]="userMenu" nbContextMenuTrigger="click">
    <nb-icon icon="archive-outline"></nb-icon>الصرافة
  </button>
  <button nbButton status="primary" shape="round" [nbContextMenu]="userMenu" nbContextMenuTrigger="click">
    <nb-icon icon="archive-outline"></nb-icon>الكشوفات
  </button>
  <button nbButton status="primary" shape="round" [nbContextMenu]="userMenu" nbContextMenuTrigger="click">
    <nb-icon icon="archive-outline"></nb-icon>إدارة المستخدمين
  </button>
  <button nbButton status="primary" shape="round" [nbContextMenu]="userMenu" nbContextMenuTrigger="click">
    <nb-icon icon="archive-outline"></nb-icon>الاعدادات
  </button> -->
</div>
<div class="header-container" *ngIf="companyLogo">
    <img [src]="companyLogo" height="35" />
</div>
<div class="header-container">
  <nb-actions size="small">

    <!-- <nb-action class="control-item search">
      <nb-search type="rotate-layout" (click)="startSearch()" matRipple [matRippleUnbounded]="true" [matRippleCentered]="true"></nb-search>
    </nb-action> -->
    <nb-action class="control-item" icon="expand-outline" *ngIf="!screenIsFull" (click)="openFullScreen()" matRipple
      [matRippleUnbounded]="true" [matRippleCentered]="true"></nb-action>
    <nb-action class="control-item" icon="collapse-outline" *ngIf="screenIsFull" (click)="closeFullScreen()" matRipple
      [matRippleUnbounded]="true" [matRippleCentered]="true"></nb-action>

    <!-- <nb-action class="control-item globe" icon="globe-2-outline" [nbContextMenu]="languagesMenu" matRipple [matRippleUnbounded]="true" [matRippleCentered]="true">

    </nb-action> -->
    <nb-action class="control-item notifications" icon="home-outline" (click)="home()" matRipple
      [matRippleUnbounded]="true" [matRippleCentered]="true"></nb-action>
    <nb-action class="control-item notifications" icon="log-out-outline" (click)="logout()" matRipple
      [matRippleUnbounded]="true" [matRippleCentered]="true"></nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" matRipple [matRippleUnbounded]="false"
      [matRippleCentered]="true">
      <nb-user [nbContextMenu]="userMenu" [nbContextMenuTag]="tag" [onlyPicture]="userPictureOnly" [name]="user?.name"
        [picture]="user?.picture">
      </nb-user>
    </nb-action>
    <nb-action>

    </nb-action>
  </nb-actions>
</div>